
<GenAILayout class="intent-selection">
  <template #nav>
    <cvt-top-nav-bar
      mode="LIGHT"
      :route="genAISelectTemplate"
      variant="embedded"
      :class="'cvt-top-nav-bar'"
      template-name="Let's get started!"
      :fixed="true"
      :light-logo="logo"
      :dark-logo="logo"
      :type="orgName"
      @switch-preview="switchViewMode"
      @use-template="() => useTemplate()"
      @back="navigateToChooseATemplate"
    />
  </template>

  <cvt-left-side-bar class="marketplace-left-nav-bar intent-sidebar">
    <cvt-button
      :loading="loading"
      class="back-btn"
      text=""
      icon="arrow-left"
      @click="goBack"
    />
    <h2 class="template-ready-title mt-4">
      {{ $t('gen_ai.template.title') }}
    </h2>
    <p class="template-review mt-3">
      {{ $t('gen_ai.template.description_1') }}
      <b>{{ $t('gen_ai.template.description_2') }}</b>
      {{ $t('gen_ai.template.description_3') }}
      <b>{{ $t('gen_ai.template.description_4') }}</b>
      {{ $t('gen_ai.template.description_5') }}
    </p>
    <cvt-button
      :loading="loading"
      class="mt-3 magic-btn"
      :text="$t('gen_ai.template.continue_btn')"
      icon="wand-magic"
      :prepend="true"
      @click="switchTemplate"
    />
  </cvt-left-side-bar>
  <div class="content-wrapper position-relative">
    <div v-if="loading" class="working-on-block">
      <div class="working-on-block__container">
        <h3 class="loader-message">{{loadingMessage}}</h3>
      </div>
    </div>
    <div class="w-100, h-100">
      <div :class='{"content": true, "d-none": currentAPIData.previewURL === "", "mobile": viewMode !== "desktop"}'>
        <iframe
          :key="currentAPIData.previewURL"
          :src="currentAPIData.previewURL"
          frameborder={0}
          @load="iframeLoaded"
        />
      </div>
    </div>
  </div>
</GenAILayout>
